import { createSelector } from 'reselect';
export var getSegments = function (state) { return state.segments; };
export var hasSelectedSegments = createSelector(getSegments, function (segments) { var _a, _b; return !!((_a = segments.departure) === null || _a === void 0 ? void 0 : _a.iata) && !!((_b = segments.arrival) === null || _b === void 0 ? void 0 : _b.iata); });
